export const TELECONSULTATION_FINISHED = 'TELECONSULTATION_FINISHED'

export const teleconsultationFinished = () => ({
  type: TELECONSULTATION_FINISHED,
})
